import { useAuth } from "../contexto/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export const useAuthNavigation = () => {
  const { user, login, isLoading, logout } = useAuth();
  const navigate = useNavigate();

  const loginAndRedirect = (username) => {
    login(username);
    navigate("/dashboard");
  };

  const logoutAndRedirect = () => {
    logout();
    navigate("/login");
  };

  return {
    user,
    isLoading,
    login: loginAndRedirect,
    logout: logoutAndRedirect,
  };
};
